module.exports = __webpack_public_path__ + "img/kuang.94feae60.png";